const url = document.querySelectorAll(".js-menu-current");
const paths = location.pathname.split("/");
const current_path = paths[1];

url.forEach((e) => {
  const v = e.getAttribute("href");
  if (v.split("/")[1] == current_path) {
    e.classList.add("is-current");
  }
});

// const mapValue = Object.keys(url).map((value) => {
//   const paths = url[value].pathname.split("/");
//   console.log(url[value]);
//   console.log(paths[1]);
// });
